export default class TagCollection
{
	constructor(collection)
	{
		this.setTags(collection);

		return this;
	}

	setTags(collection)
	{
		this.collection = collection;

		return this;
	}

	getTags()
	{
		return this.collection;
	}

	filterChecked()
	{
		return new TagCollection(Array.from(this.getTags().filter(tag => {
			return tag.getIsChecked();
		}).values()));
	}

	getIds()
	{
		return Array.from(this.getTags()).map(tag => {
			return tag.getId();
		});
	}

	reset()
	{
		this.getTags().forEach(tag => {
			return tag.reset();
		});

		return this;
	}
}
